// © 2026 Camp Promethean, LLC. All Rights Reserved.

export const AGORA_COMING_SOON_TOAST =
  "The Camp Promethean marketplace — supplies sized to your facility, experts on demand, and industry talent in one place.";

export function AgoraComingSoonTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Agora — Coming Soon</p>
      <p>
        The Camp Promethean marketplace connects your cultivation operation with the
        supplies, expertise, and people it needs to grow.
      </p>
      <div>
        <p className="font-medium">What&apos;s included</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>
            <span className="font-medium">Products</span> — procurement sized to your canopy,
            plant counts, and crop schedule, priced for your scale
          </li>
          <li>
            <span className="font-medium">Professionals</span> — vetted consultants, educators,
            and specialists for IPM triage, facility buildouts, and on-demand guidance
          </li>
          <li>
            <span className="font-medium">People</span> — the industry hiring ground for
            profiles, resumes, and open roles
          </li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Supplies for your facility, experts for your problems, and talent for your team — all
        in one marketplace.
      </p>
    </div>
  );
}
